import Icon from '../components/Icon.vue'

Icon.register({
  'file-pdf': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M181.9 256.1C176.9 240.1 177 209.2 179.9 209.2 188.3 209.2 187.5 246.1 181.9 256.1zM180.2 303.3C172.5 323.5 162.9 346.6 151.8 366 170.1 359 190.8 348.8 214.7 344.1 202 334.5 189.8 320.7 180.2 303.3zM86.1 428.1C86.1 428.9 99.3 422.7 121 387.9 114.3 394.2 91.9 412.4 86.1 428.1zM248 160H384V488C384 501.3 373.3 512 360 512H24C10.7 512 0 501.3 0 488V24C0 10.7 10.7 0 24 0H224V136C224 149.2 234.8 160 248 160zM240 331.8C220 319.6 206.7 302.8 197.3 278 201.8 259.5 208.9 231.4 203.5 213.8 198.8 184.4 161.1 187.3 155.7 207 150.7 225.3 155.3 251.1 163.8 284 152.2 311.6 135.1 348.6 123 369.8 122.9 369.8 122.9 369.9 122.8 369.9 95.7 383.8 49.2 414.4 68.3 437.9 73.9 444.8 84.3 447.9 89.8 447.9 107.7 447.9 125.5 429.9 150.9 386.1 176.7 377.6 205 367 229.9 362.9 251.6 374.7 277 382.4 293.9 382.4 323.1 382.4 325.1 350.4 313.6 339 299.7 325.4 259.3 329.3 240 331.8zM377 105L279 7C274.5 2.5 268.4 0 262 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM302.9 360.3C307 357.6 300.4 348.4 260.1 351.3 297.2 367.1 302.9 360.3 302.9 360.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-pdf.js
// module id = m7g/
// module chunks = 144